<main>
  <div class="container">

    <div class="row mb-4">

      <div class="col">

        <div class="general-title">
          <h2>Declaração Anual</h2>
        </div>

        <div class="text-page mt-3 mt-md-5">
          <p>
            A FUSAN, informa abaixo os valores pagos ao Plano Setorial Viva Mais Previdência.
          </p>
        </div>

      </div>

    </div>

    <div class="row">
      <div class="col-auto">

        <div class="filters pt-2 pt-lg-4 pl-2 pl-lg-4 pb-3 pb-lg-5">
          <div class="row">
            <div class="col-auto mr-3 mb-2 mb-lg-0">
              <label for="data_inicio">Ano</label>
              <select name="data_inicio" id="data_inicio" [(ngModel)]="ano">
                @for (item of anos; track item) {
                  <option [value]="item.ANO">{{item.ANO}}</option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-auto">

        @if (exibeBotaoPDF) {
          <button class="btn btn-light text-danger" style="font-size: 16px;" (click)="gerarPDF()">
            @if (!loadingGerarPDF) {
              <span><i class="fas fa-file-pdf"></i></span>
            }
            @if (loadingGerarPDF) {
              <span><i class="fas fa-spinner fa-spin"></i></span>
            }
            Gerar Comprovante
          </button>
        }

      </div>
    </div>

  </div>
</main>